<div class="review-status">
  @if (loading) {
    <div class="review-loading" matTooltip="Saving review status…">
      <mat-spinner diameter="16" mode="indeterminate"></mat-spinner>
      <span>Updating…</span>
    </div>
  } @else {
    <mat-checkbox
      class="review-toggle"
      [class.complete]="isComplete"
      [checked]="isComplete"
      (click)="onToggle($event)"
      [matTooltip]="
        isComplete
          ? 'Mark this finding as needs reviewing'
          : 'Mark this finding as review complete'
      "
    >
      {{ isComplete ? 'Review complete' : 'Needs reviewing' }}
    </mat-checkbox>
  }
  @if (isComplete && (reviewedBy || reviewedAt)) {
    <small class="reviewed-meta">
      @if (reviewedBy) {
        Reviewed by {{ reviewedBy }}
      }
      @if (reviewedAt) {
        · {{ reviewedAt | date: 'medium' }}
      }
    </small>
  }
</div>
